export default __webpack_public_path__ + "static/media/vii_logo_full.dade375e.png";